/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/InputCaption/theme';

export const InputCaptionTheme = theme;
